<template>
  <div class="form-group">
    <label class="custom-label">{{labelDesc}}</label>
    <div class="form text-right">
      <textarea class="custom-input form-control " v-model="value" @change="changeValue" @keyup="changeValue">{{this.value}}</textarea>
      <button class="btn btn-dark my-3 btn-sm" @click="changeValue">{{$t('ct-apply')}}</button>
    </div>
  </div>
</template>

<script>

	export default {
		name: 'TextAreaComponent',
		data() {
			return {
				element: null,
				value: '',
				labelDesc: 'opa',
				callback: null,
			}
		},
		methods: {
			changeValue() {
				this.callback();
			},
			setValues(obj) {
				this.value = obj.defaultValue;
				this.element = obj.element;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;
			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  textarea {
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/TextArea.vue